import ajaxUtils from "./ajaxutils";
import utils from "./utils";
import content from "./content";

const wsController = (() => {
  let reconnectCount = 0; // 重连计数器
  let firstReconnectTime = new Date().getTime(); // 首次重连时间
  const wsClosed = (type) => {
    let ws = resetConfig.ws;
    if (!ws || ws.nativeError == "auth") {
      return;
    }
    ws.nativeError = type;
    closeWsHandler(ws);
    if (type == "error" || type == "auth") {
      return;
    }
    resetPingEvent();
  };
  const resolveAuth = (data) => {
    if (data.sta == 0) {
      // requestMessageList(); // 知你逻辑为此处刷新会话
      const list = resetConfig.msgWaiting;
      resetConfig.msgWaiting = [];
      const current = new Date().getTime();
      list.forEach((item) => {
        current - item.createTime < 120000 && sendWs(item);
      });
    } else {
      wsClosed("auth");
      if (data.errcode == 4001 || data.errcode == 4003) {
        resetConfig.resetTimeWs = Number.MAX_VALUE;
      }
      if(!shouldReconnect()){
        const sysMsg = {
          msgtype: "system",
          content: "连接已断开，请刷新页面重试！",
          mid: "native_" + new Date().getTime(),
        };
        content.showMoreMessage(sysMsg, true)
      }
      if (data.data.errcode === 10003 && shouldReconnect()) {// websocket接收token过期重新登录
        content.startProcess({
          errcode: data.data.errcode,
          token,
          type: "needMsgList",
        });
        reconnectCount++; //重连次数增加
      }
    }
  };
  const onopen = (evt, params) => {
    if (params && params.type === "needMsgList") {
      requestMessageList();
    }
    utils.log("tkyj+++onopen+++" + JSON.stringify(evt.data));
    //this.setState({resetTime: 0});
  };
  const onclose = (evt) => {
    utils.log("tkyj+++onclose+++" + evt.data);
    //this.setState({resetTime: 0});
    wsClosed();
  };
  const onerror = (evt) => {
    utils.log("tkyj+++onerror+++" + evt.data);
    //this.setState({resetTime: 0});
    wsClosed("error");
  };
  const onmessage = (evt) => {
    let data = evt.data;
    if (!(typeof evt.data == "string")) {
      return;
    }
    data = JSON.parse(data || "{}");
    utils.log("tkyj++++onmessage++++" + JSON.stringify(data));
    switch (data.type) {
      case "auth": {
        resolveAuth(data);
        break;
      }
      case "pong": {
        resetConfig.pingCount = 0;
        break;
      }
      case "ack": {
        if (data.data.ackid) {
          const ids = data.data.ackid.split("_");
          const list = this.props.talkList;
          utils.travelTalkList(list, (rItem, i, j) => {
            if (rItem.sid == ids[0]) {
              const messageData = rItem.message;
              if (messageData && messageData.length > ids[1]) {
                const mid = data.data.mid;
                if (rItem.createTime) {
                  for (let kk = messageData.length - 1; kk >= ids[1]; kk--) {
                    if (messageData[kk].mid == mid) {
                      messageData.splice(kk, 1);
                      break;
                    }
                  }
                }
                const message = messageData[ids[1]];
                message.result = data.sta ? -1 : undefined;
                message.mid = mid;
                !message.internal && (rItem.unread = 0);
                rItem.lasttime < message.ctime &&
                  (rItem.lasttime = message.ctime);
                list[i].splice(j, 1);
                utils.insertSession(list[i], rItem, i == 0);
                this.props.setTalkList(list);
              }
              return true;
            }
          });
        }
        break;
      }
      case "close": {
        if (!data.data || !data.data.sid) {
          return;
        }
        const list = this.props.talkList;
        utils.travelTalkList(list, (rItem, i, j) => {
          if (rItem.sid == data.data.sid) {
            const cTalk = this.props.currentTalk;
            if (cTalk.sid == data.data.sid) {
              cTalk.status = "close";
            }
            list[i].splice(j, 1);
            this.props.setTalkList(list);
            return true;
          }
        });
        break;
      }
      case "message": {
        if (data.data && actionCBs.messageReceived) {
          actionCBs.messageReceived(data.data);
        }
        break;
      }
      case "session": {// 新增
        break;
      }
      case "sessionchange": {//排队
        if (!data.data || data.data.length == 0) {
          return;
        }
        const list = this.props.talkList;
        let access = {};
        for (const ii in data.data) {
          utils.travelTalkList(list, (rItem, i, j) => {
            if (rItem.sid == data.data[ii].sid) {
              rItem.kfid = data.data[ii].kfid;
              if (this.props.globalData.kfid == rItem.kfid) {
                access.icon = rItem.avatar;
                access.sid = rItem.sid;
                if (i != 0) {
                  list[i].splice(j, 1);
                  utils.insertSession(list[0], rItem, true);
                }
              } else {
                if (i != 1) {
                  list[i].splice(j, 1);
                  utils.insertSession(list[1], rItem);
                }
              }
              return true;
            }
          });
        }
        access.icon &&
          notificationUtils.startNotification(
            this,
            4,
            "您有新的转接，请及时回复！",
            (access.sid || "access_") + new Date().getTime(),
            access.icon
          );
        this.props.setTalkList(list);
        break;
      }
      default: {
        break;
      }
    }
  };
  const sendWs = (data) => {
    const ws = resetConfig.ws;
    if (ws && ws.nativeError == "auth") {
      return;
    }
    utils.log("tkyj+++sendWs+++" + JSON.stringify(data));
    data.count = data.count == undefined ? 1 : data.count;
    try {
      if (!localStorage.wsNativeId) {
        localStorage.wsNativeId = Math.random();
      }
      data.message.wsNativeId = localStorage.wsNativeId;
      ws.send(JSON.stringify(data.message));
    } catch (e) {
      utils.log("tkyj+++++tryresend++e++" + JSON.stringify(e));
      if (!data.count) {
        return;
      }
      data.count--;
      data.createTime = new Date().getTime();
      resetConfig.msgWaiting.push(data);
      if (data.message.type == "ping") {
        utils.log("tkyj+++++tryresend++resetWs+++++++");
        closeWsHandler(ws);
        resetWs(token);
      } else {
        utils.log("tkyj++tryresend++pingCount+++" + resetConfig.pingCount);
        resetPingEvent(1, true);
        // this.sendWs({message: {type: 'ping'}})
      }
    }
    return true;
  };
  const continuePing = () => {
    resetConfig.pingInterval = setInterval(() => {
      const data = { message: { type: "ping" }, count: 0 };
      resetConfig.pingCount++;
      utils.log("tkyj++++++++pingInterval+++++++" + resetConfig.pingCount);
      if (resetConfig.pingCount > MAX_PING_COUNT) {
        data.count = 1;
        resetConfig.pingCount = 0;
      }
      sendWs(data);
    }, 3000);
  };
  const closeWsHandler = (ws) => {
    if (!ws) {
      return;
    }
    ws.wyFinished = true;
    ws.onclose = ws.onerror = ws.onmessage = ws.onopen = () => {};
    // resetConfig.ws = undefined;
    showBreakConnect();
  };
  const showBreakConnect = () =>{
    const sysMsg = {
      msgtype: "system",
      content: "连接已断开，请刷新页面重试！",
      mid: "native_" + new Date().getTime(),
    };

    content.showMoreMessage(sysMsg, true)
    
  };
  const resetPingEvent = (value, rightNow) => {
    resetConfig.pingCount = value || MAX_PING_COUNT;
    if (rightNow) {
      sendWs({ message: { type: "ping" } });
    }
  };
  const resetWs = (token, params) => {
    if (resetConfig.ws) {
      return;
    }
    const currentTime = new Date().getTime();
    const lastTime = resetConfig.resetTimeWs;
    utils.log("tkyj+++resetWs+++lastTime+++" + lastTime);
    if (currentTime - lastTime < 10000) {
      resetPingEvent();
      return;
    }
    utils.log("tkyj+++resetWs+++from+++" + token);
    resetConfig.resetTimeWs = currentTime;
    const ws = new WebSocket(
      `${
        ajaxUtils.testDomain ? "wss://msg.zhinikefu.com" : "wss://xmsg.h5bqb.top"
      }/wykf/websocket/webplugin?version=0.1.1&token=${token}`
    );
    ws.onopen = (evt) => {
      onopen(evt, params);
    };
    ws.onclose = (evt) => {
      onclose(evt);
    };
    ws.onerror = (evt) => {
      onerror(evt);
    };
    ws.onmessage = (evt) => {
      onmessage(evt);
    };
    resetConfig.ws = ws;
  };
  const MAX_PING_COUNT = 3;
  const resetConfig = {
    ws: undefined,
    resetTimeWs: 0,
    pingCount: 0,
    msgWaiting: [],
  };
  const actionCBs = {};
  let token = "";
  window.addEventListener("online", (e) => {
    if (shouldReconnect()) {// 检查是否需要重连
      resetConfig.ws = undefined;
      setTimeout(() => {
        content.startProcess({
          errcode: 10003,
          token,
          type: "needMsgList",
        });
        reconnectCount++; //重连次数增加
      }, 1000);
    }
  });
  function shouldReconnect() {
    if (reconnectCount === 0) {// 首次重连
      firstReconnectTime = new Date().getTime();
      return true;
    }
    const currentTime = new Date().getTime();
    const timeDifference = (currentTime - firstReconnectTime) / (1000 * 60 * 60); // 当前与首次重连的时间间隔
    if (timeDifference > 1) {// 首次重连超过1小时，重置重连次数和首次重连时间
      reconnectCount = 0;
      firstReconnectTime = currentTime;
    }
    
    return reconnectCount < 10;// 检查重连次数是否超过10次
  }
  return {
    init: (params) => {
      utils.log("tkyj+++++init+++++++++");
      actionCBs.messageReceived = params.messageReceived;
      token = params.token;
      resetConfig.ws = undefined;
      resetWs(params.token, params.params);
      continuePing();
    },
    sendMsgH(params) {
      if (!token) {
        return;
      }
      let channel_id = utils.getParameterByName("channel_id");
      let client_id = utils.getParameterByName("client_id");
      let add_params = `&channel_id=${channel_id}&client_id=${client_id}`;
      ajaxUtils.httpRequest({
        type: "POST",
        url: "/wykf/api/v1/enterprise/webplugin/message?version=0.1.1" + add_params,
        data: { token, data: params.message },
        success: (result) => {
          utils.log("tkyj++sendMsgH+++result++++" + JSON.stringify(result));
          params.cb && params.cb(0, result.data);
        },
        error: (res) => {
          if (res.sta === 10003 && params.message.msgtype === "open_chat") {// open_chat自动重试
            content.startProcess({
              errcode: res.sta,
              token,
              type: "needMsgList",
            });
            setTimeout(() => {
              startProcess("sendMsgH", params);
            }, 3000);
          } else {
            if (params.sendCount < 4) {//消息发送失败重试3次
              params.cb &&
                params.cb(
                  -1,
                  { msg: res.msg, errcode: res.sta, token },
                  params.sendCount + 1
                );
            }
          }
        },
      });
    },
    closeWsPingEvent(params) {
      if (params.errcode === 10003 && params.token) {
        clearInterval(resetConfig.pingInterval);
      }
      wsClosed();
    },
  };
})();
const startProcess = (action, params) => {
  wsController[action](params);
};
export default {
  startProcess,
};


// WEBPACK FOOTER //
// ./src/js/wsUtils.js